import http from "../http-common";

export default class FotoService {

  getFotosByMaand(maand) {
    return http.get("/api/fotos/" + maand);
  }

  getMaandenMetFotos() {
    return http.get("/api/fotos/maanden");
  }
}
